const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Osvedčenie o evidencii vozidla',
	'vehicleRegistrationDocument.description':
		'Nahrajte zreteľné fotografie požadovaných strán osvedčenia o evidencii vozidla.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Predná strana osvedčenia o evidencii',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Odfoťte zreteľne prednú stranu osvedčenia o evidencii.',
	'vehicleRegistrationDocument.RegistrationDocument.headline':
		'Predná strana osvedčenia o evidencii',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Predná strana osvedčenia o evidencii - príklad',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Predná strana osvedčenia o evidencii',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Zadná strana osvedčenia o evidencii',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Odfoťte zreteľne zadnú stranu osvedčenia o evidencii.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Zadná strana osvedčenia o evidencii',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Zadná strana osvedčenia o evidencii - príklad',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Zadná strana osvedčenia o evidencii',
	'vehicleRegistrationDocument.validationHeadline': 'Chýbajúce fotografie',
	'vehicleRegistrationDocument.validationDescription': 'Pridajte nasledujúce fotografie:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Odfoťte osvedčenie o evidencii vozidla',
	'review.stepDescription.vehicleRegistrationDocument': 'Osvedčenie o evidencii vozidla',
	'approval.additionalCosts': 'Additional costs',
	'approval.button.approve': 'I accept the offer',
	'approval.button.disapprove': 'I do not accept the offer',
	'approval.calculationPDF': 'Calculation overview PDF',
	'approval.description':
		'Check if the bank account number given below is correct. If so, confirm the estimate and the above amount will be transferred to your account.',
	'approval.discount': 'Discount',
	'approval.headline': 'Repair amount',
	'approval.labourCosts': 'Labour costs',
	'approval.lacquerCosts': 'Paintwork',
	'approval.lacquerMatCosts': 'Paint materials',
	'approval.payoutAmount': 'Payout amount',
	'approval.repairAmount': 'Repair amount',
	'approval.repairAmountGross': 'An amount of the damage',
	'approval.retention': 'Retention',
	'approval.sparePartCosts': 'Spare parts',
	'approval.tax': 'VAT',
	'blockedByDevice.headline': 'Program PolicyCheck nepodporuje prehliadače pre počítače',
	'blockedByDevice.description':
		'Vážený klient,\r\nľutujeme, fotoobhliadku poisťovaného vozidla nie je možné uskutočniť \r\nprostredníctvom PC.\r\nKliknite na link vo svojom smartfóne a pokračujte ďalej podľa inštrukcií.\nZa porozumenie ďakujeme.\nS úctou\nAllianz - Slovenská poisťovňa',
	'bodyshop.headline': 'Workshops in your area',
	'bodyshop.mainError': 'Workshops in your area could not be loaded ...',
	'bodyshop.mainLoader.loadingLocation': 'Determining your location ...',
	'bodyshop.mainLoader.loadingWorkshop': 'Loading workshops in your area ...',
	'button.accept': 'Súhlasím',
	'button.addLater': 'Neskôr',
	'button.backchangeImage': 'Späť a zmeniť fotku',
	'button.call': 'Call',
	'button.changeImage': 'Zmeniť fotku',
	'button.close': 'Zatvoriť',
	'button.contact': 'Contact',
	'button.continue': 'Pokračovať',
	'button.dataProtection': 'Data protection',
	'button.deleteImage': 'Zmazať fotku',

	'button.help': 'Pomoc',
	'button.imprint': 'Imprint',
	'button.liveChat': 'Live-Chat',
	'button.next': 'Ďalej',
	'button.ok': 'Doplniť',
	'button.onApproval': 'Get calculation',
	'button.onCallback': 'Callback Note received',
	'button.onExpertRequest': 'Expert request',
	'button.onInsuranceExpert': 'Steering out to insurance expert',
	'button.onLanding': 'Without onboarding',
	'button.onOnboarding': 'Onboarding',
	'button.onVideocall': 'Video review',
	'button.payout': 'Yes, please pay',
	'button.prev': 'Späť',
	'button.repair': 'Arrange for repair',
	'button.select': 'Select',
	'button.selectPhoto': 'Select a photo',
	'button.showTutorial': 'Watch tutorial',
	'button.showWhatsApp': 'WhatsApp-Message',
	'button.start': 'Začať',
	'calculationDetailsModal.additionalCosts': 'Additional costs',
	'calculationDetailsModal.labourCosts': 'Labour costs',
	'calculationDetailsModal.lacquerCosts': 'Lacquer costs',
	'calculationDetailsModal.spareParts': 'Spare parts',
	'calculationDetailsModal.total': 'Total',
	'callback.description':
		'Unfortunately no calculation was possible in your case. We will call you within 24 hours on weekdays to discuss further action with you.',
	'callback.headline': 'Your damage has been assessed.',
	'completeDamageDescriptionModal.description': 'Please describe briefly how the damage occurred.',
	'completeDamageDescriptionModal.headline': 'Pomoc',
	'completeDamageImages.description': 'Add at least 2 damage photos from diffrent distances.',
	'completeDamageImages.headline': 'Pomoc',
	'completeDashboardMileageModal.dashboardImage': 'Stav najazdených kilometrov',
	'completeDashboardMileageModal.description': 'Please provide the information below:',
	'completeDashboardMileageModal.hasValidMileage': 'The vehicle mileage',
	'completeDashboardMileageModal.headline': 'Pomoc',
	'completeFourAdditionalPicturesModal.description': 'Prosím, doplňte fotku:',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Stav najazdených kilometrov',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Ovládací panel vozidla',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Fotka dobre viditeľného VIN',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Fotka čelného skla',
	'completeFourAdditionalPicturesModal.headline': 'Pomoc',
	'completeOverallDashboardImageModal.description': 'Prosím, doplňte fotku:',
	'completeOverallDashboardImageModal.hasOverallDashboardImage': 'ovládacieho panela',
	'completeOverallDashboardImageModal.headline': 'Pomoc',
	'completePayoutInformationModal.accountHolder': 'Account holder',
	'completePayoutInformationModal.accountHolderIBAN': 'IBAN of the account holder',
	'completePayoutInformationModal.description': 'Prosím, doplňte fotku:',
	'completePayoutInformationModal.headline': 'Pomoc',
	'completePoliceReportModal.description': 'Prosím, doplňte fotku:',
	'completePoliceReportModal.hasAccidentOnAlcoholOrDrugs':
		'Were you under the influence of alcohol or drugs?',
	'completePoliceReportModal.hasAccidentOwnFault': 'Did you cause the accident?',
	'completePoliceReportModal.hasDamageDescription': 'Damage description',
	'completePoliceReportModal.hasPoliceInformed': 'Was the accident recorded by police?',
	'completePoliceReportModal.hasPoliceReportExists': 'Is there a police report?',
	'completePoliceReportModal.headline': 'Pomoc',
	'completeVehicleImagesModal.description': 'Prosím, doplňte fotku:',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Photo of the vehicle front',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'predok a ľavá strana vozidla',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'predok a ľavá strana vozidla',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Photo of the vehicle left',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Photo of the vehicle back',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'zadok a pravá strana vozidla',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'zadok a pravá strana vozidla',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Photo of the vehicle right',
	'completeVehicleImagesModal.headline': 'Pomoc',
	'completeVehicleInformationModal.dashboardImage': 'Stav najazdených kilometrov',
	'completeVehicleInformationModal.description': 'Prosím, doplňte fotku:',
	'completeVehicleInformationModal.hasValidMileage': 'Mileage of the vehicle',
	'completeVehicleInformationModal.headline': 'Pomoc',
	'completeVehicleInformationModal.isRegistrationDocument2Uploaded':
		'Photo of the vehicle registration certificate (reverse)',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration certificate',
	'completeVinModal.description': 'Please provide the information below:',
	'completeVinModal.hasVin': 'VIN vozidla',
	'completeVinModal.headline': 'Pomoc',
	'completeWindshieldImageModal.description': 'Prosím, doplňte fotku:',
	'completeWindshieldImageModal.hasWindshieldImage': 'Photo of the windshield',
	'completeWindshieldImageModal.headline': 'Pomoc',
	'connectionError.description': 'Spojenie prerušené. Prosím skúste znova.',
	'connectionError.title': 'Spojenie prerušené',
	'damageDescription.button.back': '« Späť',
	'damageDescription.button.help': 'Pomoc',
	'damageDescription.button.next': 'Ďalej »',
	'damageDescription.headline.first': 'Damage Description',
	'damageDescription.paragraph.first':
		'Please briefly describe how the damage has occurred. You can also use the dictation feature of your mobile phone. Click to the text field and hold the microphone icon.',
	'damageDescription.placeholder':
		'For example: At an intersection another car hit me from the side. My front left fender was pushed in.',
	'damageImages.additionalImages': 'Additional photos of the damages',
	'damageImages.description':
		'Add at least {imageCount, number} damage {imageCount, plural, one {photo of each damage} other {photos of each damage. Photos should be taken from different distances (zoom-in/whole element)}}. Important: the damage should be fully visible',
	'damageImages.headline': 'Damage Images',
	'damageImages.optionalDamageImages': 'Optionally, add more photos showing the damages.',
	'damageImages.photo': 'photo of the damage',
	'damageImagesExampleModal.headline': 'Damage pictures - example',
	'dashboardImageExampleModal.headline': 'Príklad fotky stavu najazdených kilometrov',
	'dashboardMileage.dashboard.paragraph':
		'Take a photo of the vehicle dashboard with fully visible mileage. If your vehicle has electronic displays, please turn them on.',
	'dashboardMileage.dashboard.title': 'Stav najazdených kilometrov',
	'dashboardMileage.headline.first': 'Mileage',
	'dashboardMileage.paragraph.first': 'Zadajte stav najazdených kilometrov',
	'dashboardMileage.paragraph.mileageAutoFilled':
		'Mileage was automatically filled based on uploaded photo. Please check if value is proper',
	'dashboardMileage.placeholder': 'for example 150000 km',
	'dataPrivacyModal.headline': 'Podmienky používania',
	'editPhoto.edit': 'Zmeniť',
	enumeration: '{position, select, first {} last { and } other {, }}{enumeration}',
	'feedback.button.send': 'Odoslať',
	'feedback.description': '',
	'feedback.headline': 'Fotky ste nám úspešne odoslali',
	'feedback.headline.policyCheck': 'Fotky ste nám úspešne odoslali',
	'feedback.rating': 'How do you rate the claim settlement with EasyClaim?',
	'feedback.rating.policyCheck':
		'Ako hodnotíte svoju spokojnosť s týmto online nástrojom na online obhliadku? 5 hviezdičiek je najlepšie hodnotenie.',
	'feedback.yourOpinion': 'Komentár',
	'fourAdditionalPictures.mileage.description':
		'Prosím, odfoťte stav najazdených kilometrov. Ak máte elektronický tachometer, prosím, zapnite displej.',
	'fourAdditionalPictures.mileage.enter': 'Zadajte stav najazdených kilometrov',
	'fourAdditionalPictures.mileage.title': 'Stav najazdených kilometrov',
	'fourAdditionalPictures.overallDashboard.description':
		'Odfoťte celý zapnutý ovládací panel vozidla.',
	'fourAdditionalPictures.overallDashboard.title': 'Ovládací panel vozidla',
	'fourAdditionalPictures.title': 'Doplňujúce fotky',
	'fourAdditionalPictures.vin.description':
		'Prosím, odfoťte VIN vozidla. Môžete ho nájsť na hrane dvier šoféra, alebo vľavo dolu na čelnom skle.',
	'fourAdditionalPictures.vin.title': 'VIN vozidla',
	'fourAdditionalPictures.windshield.description': 'Prosím, detailne odfoťte čelné sklo vozidla.',
	'fourAdditionalPictures.windshield.title': 'Čelné sklo vozidla',
	'fourAdditionalPicturesExampleModal.button.close': 'Zatvoriť',
	'fourAdditionalPicturesExampleModal.headline.first': 'Doplňujúce fotky',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Ilustračná fotka',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Ilustračná fotka',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Ilustračná fotka',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Ilustračná fotka',

	'fourDiagonalPerspectives.vehicleFrontRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Ilustračná fotka',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Ilustračná fotka',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Ilustračná fotka',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Ilustračná fotka',

	'fourPerspectivesExampleModal.button.close': 'Zatvoriť',
	'fourPerspectivesExampleModal.headline.first': 'Vozidlo',
	'helpModal.description':
		"You can't get any further with one step or have questions about the application? Please contact us! We will be glad to help you:",
	'helpModal.headline': 'Pomoc',

	'imageRecognitionFeedback2.exemplaryPhoto': 'Ilustračná fotka',
	'imageRecognitionMismatchModal.headline': 'Určite ste pridali správnu fotku?',
	'insuranceExpert.description':
		'Thank you very much. Your damage has been assessed. We will get in touch with you shortly to discuss the next steps with you.',
	'insuranceExpert.headline': 'We will contact you shortly.',
	'label.details': 'Details',
	'landing.aboutEasyclaim': 'What the EasyClaim is?',
	'landing.aboutPolicyCheck': 'What is PolicyCheck?',
	'landing.changeLang': 'Ak chcete zmeniť jazyk, kliknite sem.',
	'chooseLang.headline': 'Vyberte si preferovaný jazyk',
	'landing.dataPrivacyLink': 'Pokračovaním súhlasíte s podmienkami',
	'landing.headline': 'Repair estimate in just a few steps:',
	'landing.headline.policyCheck': 'Vitajte',
	'landing.paragraph': 'Digitálnu obhliadku vozidla hravo zvládnete v troch krokoch',
	'landing.stepDescription.additionalDocuments': 'Dodaj zdjęcie oświadczenia sprawcy',
	'landing.stepDescription.damageDescription': 'Opisz uszkodzenia',
	'landing.stepDescription.damageImages': 'Take photos of the damage',
	'landing.stepDescription.feedback': 'Ohodnotiť spokojnosť',
	'landing.stepDescription.fourAdditionalPictures': 'Odoslať fotky',
	'landing.stepDescription.fourDiagonalPerspectives': 'Spraviť fotky',
	'landing.stepDescription.vehicleImages': 'Take photos of the vehicle',
	'landing.stepDescription.vehicleInformation': 'Vehicle details',
	'landing.stepDescription.vinPicture': 'Dodaj zdjęcie numeru VIN znajdującego się na pojeździe',
	'landing.termsAndConditionsLink': 'Pokračovaním súhlasíte s podmienkami',
	'landing.termsAndConditionsLinkDescription': 'Prosím, pripravte si aj technický preukaz vozidla.',
	'loader.error': 'Stránku sa nepodarilo načítať. Prosím, skúste to neskôr....',
	'loader.loading': 'Načítavam...',
	'mainError.tryAgain': 'Skúsiť znova',
	'mainMenu.contact': 'Contact us',
	'mainMenu.contact.officeHours': 'Our service times: Monday - Friday 8:00 - 20:00',
	'mainMenu.contactDescription':
		'Do you have any questions? give us a call using this phone number: {hotlineNumber}',
	'mainMenu.dataPrivacy': 'Data protection',
	'mainMenu.description': 'Click on the button to view the privacy policy.',
	'mainMenu.headline': 'Data protection',
	'mainMenu.imprintDescription': 'Click on the button to open the imprint.  ',
	'mainMenu.imprintLink': 'Imprint',
	'onboarding.button.finish': "Let's go »",
	'onboarding.button.next': 'Ďalej »',
	'onboarding.headline.first': 'Take damage pictures',
	'onboarding.headline.second': 'Let calculate',
	'onboarding.headline.third': 'Get calculation',
	'onboarding.link.dataPrivacy': 'Accept data protection',
	'onboarding.link.skip': 'Skip',
	'onboarding.paragraph.first':
		'A car expert uses the pictures to calculate the amount of damage to the vehicle.',
	'onboarding.paragraph.second':
		'Simply upload a photo from the vehicle registration and the damage of the car.',
	'onboarding.paragraph.third':
		'Within a few hours you will receive the calculation. You can now decide to pay out the repair amount or to have the vehicle repaired at the bodyshop ',
	'overallDashboardImage.description': 'Odfoťte celý zapnutý ovládací panel vozidla.',
	'overallDashboardImage.headline': 'Ovládací panel vozidla',
	'overallDashboardImage.title': 'Ovládací panel vozidla',
	'overallDashboardImageExampleModal.button.close': 'Zatvoriť',
	'overallDashboardImageExampleModal.headline.first': 'Príklad fotky ovládacieho panelu',
	'payout.button.back': '« Back',
	'payout.button.help': 'Pomoc',
	'payout.button.payoutConfirm': 'Confirm payout »',
	'payout.headline.first': 'Bank account number',
	'payout.headline.second': 'Account holder',
	'payout.headline.third': 'Account number',
	'payout.paragraph': 'Please provide the bank account number for the compensation payment.',
	'perspective.front.left': 'front left',
	'perspective.front.right': 'front right',
	'perspective.rear.left': 'rear left',
	'perspective.rear.right': 'rear right',
	'registrationDocumentExampleModal.headline': 'Photo of the registration certificate - example',
	'resolverequest.button.continue': 'Submit answer',
	'resolverequest.headline': 'Additional Information required',
	'resolverequest.onload': 'Loading request...',
	'resolverequest.onload.error':
		'An error occurred while loading the request. Please try again later.',
	'resolverequest.perspective.paragraph':
		'Fotografieren Sie Ihr Fahrzeug schräg von vorne links und von hinten rechts. Das Kfz-Kennzeichen muss lesbar sein. Die Bilder werden benötigt, um einen Gesamteindruck des Fahrzeugs zu erhalten und das Kfz-Kennzeichen mit dem Fahrzeugschein abzugleichen.',
	'resolverequest.question.headline': 'We have a question',
	'review.button.back': '« Späť',
	'review.button.close': 'Finish »',
	'review.button.help': 'Pomoc',
	'review.button.next': 'Ďalej',
	'review.editViewButton': 'View / Edit',
	'review.headline.first': 'Check',
	'review.paragraph.first':
		'Make sure that all the data is entered, then click " Complete". You will receive a summary of the entered data.',
	'review.stepDescription.damageImages': 'Damage Images',
	'review.stepDescription.fourDiagonalPerspectives': 'Pictures of the perspectives',
	'review.stepDescription.mileage': 'Mileage',
	'review.stepDescription.overallDashboard': 'Picture of the dashboard',
	'review.stepDescription.vehicleFrontPerspectiveImage':
		'Pictures of the front-left of the vehicle',
	'review.stepDescription.vehicleImages': 'Vozidlo',
	'review.stepDescription.vehicleInformation': 'Vehicle details',
	'review.stepDescription.vehicleLeftPerspectiveImage':
		'Pictures of the front-right of the vehicle',
	'review.stepDescription.vehicleRearPerspectiveImage': 'Pictures of the rear-right of the vehicle',
	'review.stepDescription.vehicleRightPerspectiveImage': 'Pictures of the rear-left of the vehicle',
	'review.stepDescription.vinPicture': 'VIN vozidla',
	'review.stepDescription.windshield': 'Picture of the windshield',
	'thanks.headline.first': 'Ďakujem!',
	'thanks.paragraph.first': 'Ďakujeme, že používate EasyClaim!',
	'thanksForFeedback.headline.first': 'Thank you for your Feedback!',
	'thanksForFeedback.paragraph.first':
		"Your opinion about our service is very important to us. We're constantly working to improve EasyClaim and your feedback is an important key to our success.",
	'timeout.headline.first': 'Odkaz na aplikáciu už nie je aktívny!',
	'tooManyAttempts.description':
		'Bohužiaľ ste dosiahli limit maximálneho počtu otvorených relácií. Naši konzultanti vás budú kontaktovať neskôr.',
	'tooManyAttempts.title': 'Príliš veľa relácií',
	'tutorialModal.headline.first': 'What is behind EasyClaim?',
	'tutorialModal.paragraph.first':
		'EasyClaim is suitable for almost all body damage to a car. Your damage pictures and the accident description will be forwarded directly to one of our 350 car experts where the pictures are analyzed and claimed. Our expert teams have all worked practically for years in the workshop themselves and understand their craft very well. In addition, for more than 16 years, we have been examining claims and maintenance receipts from almost all major insurance companies and vehicle manufacturers. Your data will be compared with over 50 million verified transactions from the past and supplemented by the practical know-how of our car experts. In addition, we have built up a very extensive database over the years. We know what each screw at every manufacturer for each model costs, and what steps are needed to replace or repair a car part.',
	'tutorialModal.paragraph.second':
		'All these circumstances allow us to provide you with a realistic cost estimate in such a short time.',
	'upload.message':
		'Vaše údaje sa odosielajú. Pri slabom internetovom pripojení to môže trvať aj niekoľko minút.',
	'vehicleImages.backOverview': 'Back photo of the vehicle',
	'vehicleImages.description':
		'Prosím, odfoťte svoje vozidlo 4-krát po uhlopriečke (šikmo): predok a ľavú stranu, predok a pravú stranu, zadok a ľavú stranu, zadok a pravú stranu. Poznávacia značka vozidla musí byť jasne viditeľná na všetkých 4 fotkách.',
	'vehicleImages.details.first': 'The front-left of the vehicle',
	'vehicleImages.details.fourth': 'The rear-right of the vehicle',
	'vehicleImages.details.frontleft':
		'Take a photo of the vehicle with the whole front and left side. The license plate should be readable.',
	'vehicleImages.details.rearright':
		'Take a photo of the vehicle with the whole rear and right side. The license plate should be readable.',
	'vehicleImages.details.second': 'The rear-left of the vehicle',
	'vehicleImages.details.third': 'The front-right of the vehicle',
	'vehicleImages.frontOverview': 'Front photo of the vehicle',
	'vehicleImages.leftFrontOverview': 'Predok a ľavá strana vozidla',
	'vehicleImages.leftOverview': 'Left photo of the vehicle',
	'vehicleImages.leftRearOverview': 'Zadok a ľavá strana vozidla',
	'vehicleImages.overviewPhotos': 'Vozidlo',
	'vehicleImages.overviewPhotos.subtitle': 'Odfoťte vozidlo',
	'vehicleImages.rightFrontOverview': 'Predok a pravá strana vozidla',
	'vehicleImages.rightOverview': 'Right photo of the vehicle',
	'vehicleImages.rightRearOverview': 'Zadok a pravá strana vozidla',
	'vehicleImagesExampleModal.button.close': 'Zatvoriť',
	'vehicleImagesExampleModal.headline.first': 'Vozidlo',
	'vehicleInformation.button.back': '« Späť',
	'vehicleInformation.button.help': 'Pomoc',
	'vehicleInformation.button.next': 'Ďalej »',
	'vehicleInformation.headline.first': 'Vehicle details',
	'vehicleInformation.headline.fourth': 'Photo of the registration certificate (the reverse)',
	'vehicleInformation.headline.second': 'Photo of the registration certificate (the front)',
	'vehicleInformation.paragraph.first':
		'Take a photo of the vehicle registration certificate (the front)',
	'vehicleInformation.paragraph.fourth':
		'Take a photo of the vehicle registration certificate (the reverse)',
	'vinImagesExampleModal.button.close': 'Zatvoriť',
	'vinImagesExampleModal.headline.first': 'Ilustračná fotka VIN',
	'vinPicture.description':
		'Prosím, odfoťte VIN vozidla. Môžete ho nájsť na hrane dvier šoféra, alebo vľavo dolu na čelnom skle.',
	'vinPicture.headline': 'VIN vozidla',
	'vinPicture.title': 'VIN vozidla',
	'waitForAudit.callBack': 'For further questions, we are happy to help you:',
	'waitForAudit.description':
		'The data is submitted successfully. Our experts will now check the damage based on your data and generate a cost calculation within 2 hours (Mon-Fri 8 am-8 pm, Sat 8 am-12 pm, excluding public holidays). You will be notified by e-mail or SMS as soon as the calculation is completed.',
	'waitForAudit.description.damageFound': 'Ďakujeme za vašu dôveru v Allianz',
	'waitForAudit.description.damageNotFound': 'Ďakujeme za vašu dôveru v Allianz',
	'waitForAudit.thankYou': 'Veľmi si ceníme vaše hodnotenie',
	'waitforAudit.finish': 'Finish',
	'windshieldExampleModal.button.close': 'Zatvoriť',
	'windshieldExampleModal.headline.first': 'Ilustračná fotka čelného skla',
	'windshieldImage.description': 'Prosím, detailne odfoťte čelné sklo vozidla.',
	'windshieldImage.headline': 'Fotka čelného skla',
	'windshieldImage.title': 'Fotka čelného skla',
	'withoutPayout.description':
		'Do you wish a repair? We would be happy to assist you in selecting a qualified workshop in your area.',
	'withoutPayout.footer':
		'We will contact you as soon as possible to discuss the further procedure.',
	'withoutPayout.headline': 'We will gladly support you!',
	'timeout.bottom': ' ',
	'testcasemodal.headline': 'Upozornenie na testovací prípad!',
	'testcasemodal.accept': 'súhlasiť',
	'testcasemodal.paragraph': 'Uvedomte si, že ide o testovací prípad!',
	'testcasewarningalert.paragraph': 'Toto je testovací prípad!',

	'invalidFile.size.title': 'Nesprávna veľkosť obrázka',
	'invalidFile.size.description':
		'Veľkosť vašej fotografie je väčšia ako maximálna požadovaná veľkosť.',
	'invalidFile.extension.title': 'Typ súboru nie je podporovaný',
	'invalidFile.extension.description':
		'Zadaný typ súboru nie je podporovaný. Podporované typy súborov: .jpg, .jpeg, .jfif, .heic, .heif, .png a .bmp',

	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
